export default __webpack_public_path__ + "static/media/19.0f78cb59.png";